import ApiService from "@/services/api.service";

class SlackService extends ApiService {
  constructor() {
    super();
  }

  public async sendMessage(message: any): Promise<boolean> {
    const url = `/api/Slack/Send`;
    const response = await this.axiosInstance.post(url, message, {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.status === 200;
  }
}
export default new SlackService();
